// API utility functions for backend communication

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const submitContactForm = async (formData) => {
  const response = await fetch(`${API_URL}/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to submit form' }));
    throw new Error(error.detail || 'Failed to submit form');
  }

  const data = await response.json();
  return {
    success: true,
    message: 'Thank you. Your enquiry has been received. Our team will contact you shortly.',
    data
  };
};

export const subscribeNewsletter = async (email) => {
  const response = await fetch(`${API_URL}/api/newsletter/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to subscribe' }));
    throw new Error(error.detail || 'Failed to subscribe');
  }

  const data = await response.json();
  return {
    success: true,
    message: 'Successfully subscribed to our intelligence briefings.',
    data
  };
};
